import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { thunks as FlaggedThunks } from 'reducers/Flagged'
import NotificationActions from 'reducers/Notification'
import { NotificationType } from 'constants/enums'

const FlagHandlerProvider = ({ release, render, callback }) => {
  const dispatch = useDispatch()
  const flagged = release?.flagged

  const handleFlag = useCallback(() => {
    dispatch(
      FlaggedThunks.flag(
        release.releaseid,
        !flagged,
        () => {
          callback(!flagged)
          dispatch(
            NotificationActions.broadcastMessage(
              `${release.artist} - ${release.title}`,
              !flagged ? NotificationType.flag : NotificationType.unFlag
            )
          )
        },
        () => {}
      )
    )
  }, [release])

  return render({ handleFlag })
}

FlagHandlerProvider.propTypes = {
  release: PropTypes.object,
  render: PropTypes.func.isRequired,
  callback: PropTypes.func
}

export default FlagHandlerProvider
